export default __webpack_public_path__ + "static/media/SERVICIOS_NEGOCIOS.314f0e73.png";